import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { Location } from '@angular/common';
import { IServiceResponseBasic } from 'src/app/share/services/common.service';
import { environment } from 'src/environments/environment';
import { ExpWinAccountabilityDetailService } from './exp-win-accountability-detail.service';

@Component({
  selector: 'app-exp-win-accountability-detail',
  templateUrl: './exp-win-accountability-detail.component.html',
  styleUrls: ['./exp-win-accountability-detail.component.scss']
})
export class ExpWinAccountabilityDetailComponent implements OnInit {

  constructor(private svc: ExpWinAccountabilityDetailService, private route: ActivatedRoute, private http: HttpClient, private location: Location) { }

  viewStateDtl$: Observable<any>;
  vm: IExpWinViewModel = {};
  errorMessage?: string = '';
  successMessage?: string = '';
  workingMessage?: string = '';
  goBackFlag: boolean = false;

  ngOnInit() {
    this.viewStateDtl$ = this.svc.getExpWinAccountabilityDetailsData(
      Number(this.route.snapshot.paramMap.get("resId")),
      Number(this.route.snapshot.paramMap.get("auditLogId"))
      );
  }

  submit(resAuditLogEntryId?: number, segmentRowId?: number) {
    //console.log('resAuditLogEntryId:' + resAuditLogEntryId + ', segmentRowId:' + segmentRowId)
    this.errorMessage = '';
    this.successMessage = '';
    this.workingMessage = '';
    //if (!this.vm.body) {
    //  this.vm.errorText = 'Feedback Required';
    //  return;
    //}
    this.workingMessage = "Submitting...";
    this.vm.workflowId = resAuditLogEntryId;
    this.vm.segmentRowId = segmentRowId;

    var url = `${environment.scApiProtocol}://${environment.scApiHost}:${environment.scApiPort}/api/SantaCruz/ExpWinAccountabilityAcknowledge`;
    
    this.goBackFlag = false;
    const s = this.http.post(url, this.vm).subscribe(
      (next: IServiceResponseBasic) => {
        //console.log(next);
        this.reset();
        next.success == true ? this.successMessage = 'The Rate Acknowledged. Thank You!' : this.errorMessage = next.message;
        next.success == true ? this.goBackFlag = true : this.goBackFlag = false;
        if (next.success == false) {
          this.viewStateDtl$ = this.svc.getExpWinAccountabilityDetailsData(
            Number(this.route.snapshot.paramMap.get("resId")),
            Number(this.route.snapshot.paramMap.get("auditLogId"))
            );
        }
      },
      (err: any) => {
        console.log(err);
        this.errorMessage = err.message || err;
        this.workingMessage = undefined;
      },
      () => {
        s.unsubscribe();
        this.workingMessage = undefined;
        if (this.goBackFlag == true) {
          this.location.back();
        }
      });
  }
  reset() {
    this.vm.body = '';
    this.errorMessage = '';
    this.successMessage = '';
    this.workingMessage = '';
  }
}

interface IExpWinViewModel {
  workflowId?: number;
  segmentRowId?: number;
  body?: string;
}
/*
interface IExpWinResponse {
  success: boolean;
  message: string;
}
*/
